import { CardLinked } from './CardLinked';
export { CardLinked };
